import { useEffect, useState } from "react";
import Select from "react-select";
import { Grid, Popup } from "semantic-ui-react";
import FilterIcon from "../../../assets/commonIcon/FilterIcon";
import { CustomButton } from "../../../components/button/Button";
import { TitleView } from "../../../components/titleView/TitleView";
import { FACILITY_TYPES } from "../../../config/optionsConstants";
import { getFacilityFilter, saveFacilityFilter } from "../../../utils/cacheStorage";

const FacilityFilter = ({ refetchWithFilters }: any) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedFacilityTypes, setSelectedFacilityTypes] = useState<any>([] as any);

  useEffect(() => {
    const initFacilityTypes = () => {
      const availableFacilityTypes = getFacilityFilter();
      if (availableFacilityTypes) {
        setSelectedFacilityTypes(availableFacilityTypes);
      }
    };

    initFacilityTypes();
  }, []);

  const currentFacilityTypes = FACILITY_TYPES?.map((item: any) => {
    return {
      value: item.value,
      label: item.text
    };
  });

  const resetValue = () => {
    setSelectedFacilityTypes([]);
    const emptyFacilities: any[] = [];
    setSelectedFacilityTypes(emptyFacilities);
    saveFacilityFilter(emptyFacilities);
    refetchWithFilters(emptyFacilities);
    setIsPopupOpen(false);
  };

  const filterValue = () => {
    saveFacilityFilter(selectedFacilityTypes);
    const currentSelectedFacilityTypes = selectedFacilityTypes.map((e: any) => e.value);

    refetchWithFilters(currentSelectedFacilityTypes);
    setIsPopupOpen(false);
  };

  return (
    <Popup
      open={isPopupOpen}
      on="click"
      onOpen={() => setIsPopupOpen(true)}
      onClose={() => {
        setIsPopupOpen(false);
      }}
      size="large"
      position={"bottom left"}
      trigger={
        <Grid>
          <CustomButton
            className="filterButton"
            iconWithText
            iconChild={<FilterIcon />}
            buttonOutLine
            theme="green"
            title="Filters"
            iconChildTextCustom={"productCustomBase"}
          />
        </Grid>
      }
    >
      <Grid className="productFilterMainView">
        <Grid.Column>
          <TitleView title={"Sort By"} />
          <Grid>
            <Grid.Column computer={8} tablet={8} mobile={16}>
              <p className={`productFilterTitle`}>Facility Type</p>
              <Select
                value={selectedFacilityTypes}
                onChange={(e: any) => {
                  setSelectedFacilityTypes(e);
                }}
                isMulti
                options={currentFacilityTypes || []}
              />
            </Grid.Column>
          </Grid>
          <Grid className="pt-0">
            <Grid.Column computer={16} tablet={16} mobile={16} className="productFilterButton">
              <CustomButton
                buttonOutLine
                customBase="productFilterCustomButton"
                theme="green"
                title="Reset"
                onClick={resetValue}
              />
              <CustomButton theme="green" title="Apply" onClick={filterValue} />
            </Grid.Column>
          </Grid>
        </Grid.Column>
      </Grid>
    </Popup>
  );
};

export default FacilityFilter;
